import dayjs, {Dayjs} from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)

export const BERLIN = "Europe/Berlin"

/**
 * "Today" as the Europe/Berlin calendar day, returned as a Dayjs at local midnight so that
 * formatting it yields the Berlin YYYY-MM-DD. The server computes dates in Berlin and the nightly
 * cron warms exactly the Berlin default date, so the client must use Berlin too — otherwise a
 * client in another timezone near midnight / a month boundary can request a date the server
 * rejects as future (400) or that was never precomputed (a slow, uncached load).
 */
export function berlinToday(): Dayjs {
  return dayjs(dayjs().tz(BERLIN).format("YYYY-MM-DD"))
}
